
import { Component, Vue } from "vue-property-decorator";
import { Action, Getter, Mutation, State } from "vuex-class";
import Scale from "@/models/scale";
import Tone from "@/models/tone";
import ColorBox from "@/components/ColorBox.vue";
import ColorLabel from "@/components/ColorLabel.vue";
import ModeSelector from "@/components/ModeSelector.vue";
import Arc from "@/components/Arc.vue";
import Piano from "@/components/Piano.vue";
import ColorScalesHeader from "@/components/ColorScalesHeader.vue";

const namespace = "StudioModule";

@Component({
  components: {
    ColorBox,
    Arc,
    ColorLabel,
    ModeSelector,
    Piano,
    ColorScalesHeader
  },
  metaInfo: {
    title: 'Color Scales | Studio',
    titleTemplate: 'Color Scales | Studio',
  }
})

export default class Studio extends Vue {
  @Action('setScale', { namespace }) private setScale!: () => any;
  @Action('updateScale', { namespace }) private updateScale!: () => any;
  @Action('updateScaleNotesArray', { namespace }) private updateScaleNotesArray!: () => any;
  @Getter ("getSelectedColorsAdded", { namespace }) private getSelectedColorsAdded!: string;
  @Getter ("getSelectedColorRGBBase1", { namespace }) private getSelectedColorRGBBase1!: string;
  @Getter ("getGlslList", { namespace }) private getGlslList!: string[];
  @Mutation('setBaseHue', {namespace}) private setBaseHue!: (value: number) => any;
  @Mutation('setMode', {namespace}) private setMode!: (value: number) => any;
  @Mutation('setSelectedOctave', {namespace}) private setSelectedOctave!: (event:any) => any;
  @Mutation('setBaseNote', {namespace}) private setBaseNote!: (value: string) => any;
  @Mutation('setMenuDisplaying', {namespace}) private setMenuDisplaying!: (value: string) => any;
  @Mutation('removeSelectedColor', {namespace}) private removeSelectedColor!: (value: string) => any;
  @State ("baseHue", { namespace }) private baseHue!: number;
  @State ("baseNote", { namespace }) private baseNote!: number;
  @State ("colors", { namespace }) private colors!: string[];
  @State ("mode", { namespace }) private mode!: number;
  @State ("displayChromaticScale", { namespace }) private displayChromaticScale!: number;
  @State ("scale", { namespace }) private scale!: Scale;
  @State ("modesArray", { namespace }) private modes!: string[];
  @State ("selectedOctave", { namespace }) private selectedOctave!: number;
  @State ("selectedColor", { namespace }) private selectedColor!: string;
  @State ("notesArray", { namespace }) private notesArray!: string[];
  @State ("scaleNotesArray", { namespace }) private scaleNotesArray!: string[];
  @State ("menuDisplaying", { namespace }) private menuDisplaying!: string;
  @State ("selectedColors", { namespace }) private selectedColors!: string[];
  @Mutation private setPreviousPage!: (name: string) => any;
  @Mutation private setCurrentPage!: (name: string) => any;
  @State private previousPage!: string;
  @State private currentPage!: string;

  private mounted(){
    if(this.$route.name!=null){
      this.setPreviousPage(this.currentPage);
      this.setCurrentPage(this.$route.name);
    }
  }

  private handleHueSlider(event:any){
    this.setBaseHue(event.target.value);
    this.updateScale();
  }

  private getColor(tone: Tone[], i: number):string{
    if(this.scale.modeTones.includes(i)){
      return `${tone[this.selectedOctave].color}ff`;
    }else{
      return `${tone[this.selectedOctave].color}22`;
    }
  }

  private getDisplay(i:number):boolean{
    if(this.scale.modeTones.includes(i)){
      return true;
    }else{
      return false;
    }
  }

  private handleModeSelector(event:any){
    this.setMode(event.target.value);
    this.updateScale();
  }

  private handleNoteSelector(event:any){
    this.setBaseNote(event.target.value);
    this.updateScaleNotesArray();
  }

  private handleOctaveSlider(event:any){
    this.setSelectedOctave(event.target.value);
  }

  private getColorNote(color: string): string{

    return this.scaleNotesArray[2];
  }

  private handleMenuClick(value: string){
    this.setMenuDisplaying(value);
  }
}
